import Reveal, { Eyebrow } from "@/components/Reveal";
import HumanSilhouette from "@/components/HumanSilhouette";
import { TEAM } from "@/config/site";

export default function Team() {
  return (
    <section id="team" className="pb-24 lg:pb-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>The Team</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-cabinet text-4xl font-extrabold tracking-tighter sm:text-5xl">
              Experienced people. Real support.
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 grid max-w-5xl gap-6 sm:grid-cols-2 md:grid-cols-3">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.08}>
              <article
                data-testid={`team-card-${i}`}
                className="flex items-center gap-5 rounded-3xl border border-ink/5 bg-white p-7 shadow-subtle transition-all duration-300 hover:-translate-y-1 hover:shadow-hover"
              >
                <span
                  className="grid h-20 w-20 shrink-0 place-items-center rounded-full bg-brand text-white"
                  aria-hidden="true"
                >
                  <HumanSilhouette gender={m.gender} className="h-11 w-11" />
                </span>
                <div>
                  <h3 className="font-cabinet text-xl font-bold tracking-tight">{m.name}</h3>
                  <p className="mt-1 text-sm text-slate-500">{m.role}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
        <p className="mt-6 text-xs text-slate-400">More team members will be featured here soon.</p>
      </div>
    </section>
  );
}
